import { render, staticRenderFns } from "./Creator.vue?vue&type=template&id=1ddd5518&scoped=true&"
import script from "./Creator.vue?vue&type=script&lang=js&"
export * from "./Creator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ddd5518",
  null
  
)

export default component.exports